import type { ChangeEvent } from 'react';
import { IFFFChangeHandlerEvent } from '../../interfaces';

export function isReactChangeEvent(
  e: IFFFChangeHandlerEvent,
): e is ChangeEvent<HTMLInputElement | HTMLSelectElement> {
  return (
    (e as ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLElement>).target !== undefined
  );
}
